/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Country,
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
} from './';

/**
 * 
 * @export
 * @interface CountryListBusinessDataResponse
 */
export interface CountryListBusinessDataResponse {
    /**
     * 
     * @type {number}
     * @memberof CountryListBusinessDataResponse
     */
    watermark?: number;
    /**
     * 
     * @type {Array<Country>}
     * @memberof CountryListBusinessDataResponse
     */
    businessData?: Array<Country> | null;
    /**
     * 
     * @type {number}
     * @memberof CountryListBusinessDataResponse
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof CountryListBusinessDataResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CountryListBusinessDataResponse
     */
    totalRecords?: number;
}

export function CountryListBusinessDataResponseFromJSON(json: any): CountryListBusinessDataResponse {
    return CountryListBusinessDataResponseFromJSONTyped(json, false);
}

export function CountryListBusinessDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryListBusinessDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'watermark': !exists(json, 'watermark') ? undefined : json['watermark'],
        'businessData': !exists(json, 'businessData') ? undefined : (json['businessData'] === null ? null : (json['businessData'] as Array<any>).map(CountryFromJSON)),
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function CountryListBusinessDataResponseToJSON(value?: CountryListBusinessDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'watermark': value.watermark,
        'businessData': value.businessData === undefined ? undefined : (value.businessData === null ? null : (value.businessData as Array<any>).map(CountryToJSON)),
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}


